export default __webpack_public_path__ + "static/media/kitchen3-afterA-1920w.86fb09c9.png";